import React from 'react';
import Axios from 'axios';
import WeeksDropdown from '../shared/WeeksDropdown';
import SubSeasonsDropdown from '../shared/SubSeasonsDropdown';

import PlayerStandings_8B from './PlayerStandings/PlayerStandings_8B';
import PlayerStandings_9B from './PlayerStandings/PlayerStandings_9B';
import PlayerStandings_10B from './PlayerStandings/PlayerStandings_10B';

import * as myConstClass from '../shared/constants/constants';

class PlayerStanding extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			subSeasons: [],
			bTournamentType: false,

			standings: [],
			standingIdx: 0,
			maxWeek: 0,

			subSeasonId: '0',
			week: 1,
			bCumulative: true,
			bWholeSeason: true,
			bIncludeFinals: false,
			bFinalsExists: false,

			loadingTable: false,
			loading: true,
		};
	
		this.cumulSwitchChange = this.cumulSwitchChange.bind(this);
		this.wholeSeasonSwitchChange = this.wholeSeasonSwitchChange.bind(this);
		this.includeFinalsSwitchChange = this.includeFinalsSwitchChange.bind(this);
		this.subSeasonChange = this.subSeasonChange.bind(this);
		this.weekChange = this.weekChange.bind(this);
		this.handleStandingIdxChange = this.handleStandingIdxChange.bind(this);
	}

	componentDidMount() {
		this.processSeason();
	}

	processSeason() {
		// console.log('processSeason');
    var season = this.props.season;
		var subSeasons = season.subSeasons;
		var subSeasonId = subSeasons[subSeasons.length - 1].id;
/*
		// -----------------------
		// v2.04.007a [2022-12-20] Set subSeason more intelligently with starting date
		var subSeasonId = subSeasons[0].id;  // subSeasons[subSeasons.length - 1].id;
		if (subSeasons.length > 1) {
			for (var ssIdx = 0; ssIdx < subSeasons.length; ssIdx++) {

				// Today is equal or greater than ssDate ?
				var ssDate = moment(subSeasons[ssIdx].startDate);
				if (moment(new Date()).isSameOrAfter(ssDate, 'day')) {
					subSeasonId = subSeasons[ssIdx].id
				}
			}
		}
*/


		// Get default parameter from season settings
		var cumulativeType = parseInt(season.standingTypePlayers);

		// Tournament type
		var bTournamentType = false;
		if(season.resultsType === myConstClass.RESTYPE_TOURNAMENT) {
			bTournamentType = true;
		}

		// New cumulative type traduction (temporaray)
		var bCumulative = false;
		var bWholeSeason = false;
		var bIncludeFinals = false;
		var bFinalsExists = false;
		var maxSubSeasonIdWithoutFinals = "0";

		var ssIdx = 0;
		var week = 1;

		for (ssIdx = 0; ssIdx < subSeasons.length; ssIdx++) {
			if (subSeasons[ssIdx].typeFinals) {
				bFinalsExists = true;
			} else {
				maxSubSeasonIdWithoutFinals = subSeasons[ssIdx].id;
			}
		}

		// validation on standingsType for only one SubSeason, display season cumulative instead
		if ((subSeasons.length <= 1) && (cumulativeType !== 0)) {
			cumulativeType = 2;
		}

		if (cumulativeType === 0) {
			bCumulative = false;
			bWholeSeason = false;
		
		} else if (cumulativeType === 1) {
			bCumulative = true;
			bWholeSeason = false;

		} else if (cumulativeType === 2) {
			bCumulative = true;
			bWholeSeason = true;
			subSeasonId = maxSubSeasonIdWithoutFinals;
		}

		this.loadStandingFromApi(subSeasons, bCumulative, bWholeSeason, bIncludeFinals, subSeasonId, week, 0);

/*
		console.log('bFinalsExists: '+ bFinalsExists);
		console.log('subSeasons.length: '+ subSeasons.length);
		console.log('maxSubSeasonIdWithoutFinals: '+ maxSubSeasonIdWithoutFinals);
*/
		// set state
		this.setState({
			subSeasons: subSeasons,
			bTournamentType: bTournamentType,
			bFinalsExists: bFinalsExists,
			maxSubSeasonIdWithoutFinals: maxSubSeasonIdWithoutFinals,
		});
	}

  cumulSwitchChange(e) {
		var bCumulative = e.target.checked;
		this.setState({
			bCumulative: bCumulative,
			loadingTable: true
		});

		this.loadStandingFromApi(this.state.subSeasons, bCumulative, this.state.bWholeSeason, this.state.bIncludeFinals, 
			this.state.subSeasonId, this.state.week, 1);
  }

  wholeSeasonSwitchChange(e) {
		var bWholeSeason = e.target.checked;
		this.setState({
			bWholeSeason: bWholeSeason,
			loadingTable: true
		});

		this.loadStandingFromApi(this.state.subSeasons, this.state.bCumulative, bWholeSeason, this.state.bIncludeFinals, 
			this.state.subSeasonId, this.state.week, 2);
  }

  includeFinalsSwitchChange(e) {
		var bIncludeFinals = e.target.checked;
		this.setState({
			bIncludeFinals: bIncludeFinals,
			loadingTable: true
		});

		this.loadStandingFromApi(this.state.subSeasons, this.state.bCumulative, this.state.bWholeSeason, bIncludeFinals, 
			this.state.subSeasonId, this.state.week, 5);
  }

	subSeasonChange(subSeasonId) {
		this.setState({
			subSeasonId: subSeasonId,
		});

		this.loadStandingFromApi(this.state.subSeasons, this.state.bCumulative, this.state.bWholeSeason, this.state.bIncludeFinals, 
			subSeasonId, this.state.week, 3);
	}

	weekChange(week) {
		this.setState({
			week: week,
		});

		this.loadStandingFromApi(this.state.subSeasons, this.state.bCumulative, this.state.bWholeSeason, this.state.bIncludeFinals, 
			this.state.subSeasonId, week, 4);
	}

	handleStandingIdxChange(standingIdx) {
		this.setState({
			standingIdx: standingIdx
		});
	}

	loadStandingFromApi(subSeasons, bCumulative, bWholeSeason, bIncludeFinals, subSeasonId, week, paramChangeIdx) {
		var _this = this;
		var cumulativeType = 0;
		var standingIdx = this.state.standingIdx;
		var maxSubSeasonIdWithoutFinals = this.state.maxSubSeasonIdWithoutFinals;

		switch (paramChangeIdx) {

			case 0:
				// Initial set
				week = -1;
				if (bCumulative) {
					if (bWholeSeason) {
						cumulativeType = 2;
					} else {
						cumulativeType = 1;
					}
				}
				break;

			case 1:
				// cumulative change

				// Reset flags
				bWholeSeason = true;
				bIncludeFinals = false;

				if (bCumulative) {
					week = -1;
					cumulativeType = 2;
					subSeasonId = maxSubSeasonIdWithoutFinals;

				} else {
					if (this.state.bTournamentType) {
						subSeasonId = subSeasons[0].id;
						week = 1;
					} else {
						subSeasonId = subSeasons[subSeasons.length - 1].id;
						week = -1;
					}
					cumulativeType = 0;
				}
				break;

			case 2:
				// wholeSeasonSwitchChange (only when bCumulative = true)

				// Reset flags
				week = -1;
				bIncludeFinals = false;

				if (this.state.bTournamentType) {
					subSeasonId = subSeasons[0].id;
				} else {
					subSeasonId = subSeasons[subSeasons.length - 1].id;
				}

				if (bWholeSeason) {
					cumulativeType = 2;
					subSeasonId = maxSubSeasonIdWithoutFinals;

				} else {

					cumulativeType = 1;
					if (this.state.bTournamentType) {
						subSeasonId = subSeasons[0].id;
					} else {
						subSeasonId = subSeasons[subSeasons.length - 1].id;
					}
				}
				break;

			case 3:
				// subSeasonChange
				if (bCumulative) {
					week = -1;
					cumulativeType = 1;
				} else {
					if (this.state.bTournamentType) {
						week = 1;
					} else {
						week = -1;
					}
					cumulativeType = 0;
				}
				break;

			case 4:
				// week change
				cumulativeType = 0;
				break;

			case 5:
				// Automatically bCumulative AND bWholeSeason
				cumulativeType = 2;
				week = -1;

				if (bIncludeFinals) {
					subSeasonId = subSeasons[subSeasons.length - 1].id;
				} else {
					subSeasonId = maxSubSeasonIdWithoutFinals;
				}
				break;
		}

		this.loadWeekMaxNumber(this.props.season._id, subSeasonId, function(maxWeek) {

			if (week === -1) {
				week = maxWeek;
			}

			// SUPPORT FOR PLAYERS IN MULTIPLE TEAMS - NEW CUMULATIVETYPE
			var convertedCumulativeType = cumulativeType;
			if (convertedCumulativeType === 0) {
				convertedCumulativeType = 3;		// Week cumulative is now 3 for players
			}

			// console.log('get standings data for subseason: ' + subSeasonId);

			Axios.get('/api/standings/season/' + _this.props.season._id + '/subs/' + subSeasonId + 
				'/playerStandings/week/' + week + '/cumulativeType/' + convertedCumulativeType).then(function(response) {

				var standings = response.data;
				//console.log("standings", standings)

				// Validation
				if (standingIdx > standings.length) {
					standingIdx = 0;
				}

				_this.setState({
					standings: standings,
					standingIdx: standingIdx,
					subSeasonId: subSeasonId,
					week: week,
					maxWeek: maxWeek,
					bCumulative: bCumulative,
					bWholeSeason : bWholeSeason,
					bIncludeFinals: bIncludeFinals,
					loadingTable: false,
					loading: false
				});
			})
		});
	}

  loadWeekMaxNumber(seasonId, subSeasonId, callback) {
    Axios.get('/api/standings/season/' + seasonId + '/subs/' + subSeasonId + '/weekMax/').then(function(response) {
			callback(response.data.week);
    });
  }

	render() {
		// console.log('PlayerStanding: render');
		return (
			<div className="minPageHeight">
				<div className="row">
				<div className="col-md-12">
					<h4>Classement des joueurs</h4>
				</div>
				</div>
				<hr className="no-print"/>

				{this.state.loading ? 
					this.displaySpinner() :
					this.displayStandings()}
			</div>
		);
	}

	displayStandings() {
		var bWholeSeason = this.state.bWholeSeason;
		var bCumulative = this.state.bCumulative;
		var bTournamentType = this.state.bTournamentType;
		var bFinalsExists = this.state.bFinalsExists;

		return (
			<div className="animated fadeIn">
			<div className="no-print">
				<div className="row">
					{this.displayCumulativeSwitch()}
				</div>
				<div className="row">
					{(bCumulative && (this.state.subSeasons.length > 1)) ? this.displayWholeSeasonSwitch() : null}
				</div>

					{/* LEAGUE ONLY */}
				<div className="row">
					{(!bTournamentType && bCumulative && bFinalsExists && bWholeSeason) ? this.displayIncludeFinals() : null}
				</div>
				<hr/>

				<div className="row">
					{!bCumulative || (bCumulative && !bWholeSeason) ? this.displaySubSeasonSelector() : null}
					{!bCumulative ? this.displayProgSelector() : null}
				</div>
			</div>

			{this.createStandings()}
			<br/><br/>
			</div>
		)
	}

	displayCumulativeSwitch() {
		var cumulativeText = "Statistiques non-cumulatives";
		if(this.state.bCumulative) {
			cumulativeText = "Statistiques cumulatives"
		}

		return (
			<div className="col-md-5">
			<label className="switch switch-3d switch-success form-control-label">
				<input type="checkbox" className="switch-input form-check-input" 
					checked={this.state.bCumulative || false} onChange={this.cumulSwitchChange}/>
				<span className="switch-label"></span>
				<span className="switch-handle"></span>
			</label>
			&nbsp;&nbsp;{cumulativeText}
			</div>
		);
	}

	displayWholeSeasonSwitch() {
		var wholeSeasonText = "Sous-saisons";
		if (!this.state.bTournamentType) {
			if (this.state.bWholeSeason) {
				wholeSeasonText = "Saison en entier";
			}
		} else {
			wholeSeasonText = "Par tableau";
			if (this.state.bWholeSeason) {
				wholeSeasonText = "Tout le tournoi";
			}
		}

		return (
			<div className="col-md-5">
			<label className="switch switch-3d switch-success form-control-label">
				<input type="checkbox" className="switch-input form-check-input" 
					checked={this.state.bWholeSeason || false} onChange={this.wholeSeasonSwitchChange}/>
				<span className="switch-label"></span>
				<span className="switch-handle"></span>
			</label>
			&nbsp;&nbsp;{wholeSeasonText}
			</div>
		);
	}

	displayIncludeFinals() {
		return (
			<div className="col-md-5">
			<label className="switch switch-3d switch-success form-control-label">
				<input type="checkbox" className="switch-input form-check-input" 
					checked={this.state.bIncludeFinals || false} onChange={this.includeFinalsSwitchChange}/>
				<span className="switch-label"></span>
				<span className="switch-handle"></span>
			</label>
			&nbsp;&nbsp;Inclure les finales
			</div>
		);
	}

	displaySubSeasonSelector() {
		var subSeasonText = "Sous-saison"
		if (this.state.bTournamentType) {
			subSeasonText = "Tableau"
		}

		// only if more than one subSeason existing
		if (this.state.subSeasons.length > 1) {
			return (
				<div className="col-md-4">
					{subSeasonText}&nbsp;&nbsp;
          <SubSeasonsDropdown value={this.state.subSeasonId} subSeasons={this.state.subSeasons} 
            subSeasonChange={this.subSeasonChange} bTournamentType={this.state.bTournamentType}></SubSeasonsDropdown>
				</div>
			);
		} else {
			return;
		}
	}

	displayProgSelector() {
		var programText = "Programme";
		if (this.state.bTournamentType) {
			programText = "Ronde";
		}
		
		return (
			<div className="col-md-2">
				{programText} &nbsp;&nbsp;
				<WeeksDropdown week={this.state.week} weekChange={this.weekChange} 
					numberOfWeeks={this.state.maxWeek}></WeeksDropdown>
			</div>
		);
	}

	createStandings() {
		if (this.state.loadingTable) {
			return (this.displaySpinner())
		} else {

			if(this.props.season.leagueType === myConstClass.LGTYPE_8B) {
				return (
					<PlayerStandings_8B season={this.props.season} standings={this.state.standings}
						standingIdx={this.state.standingIdx} bTournamentType={this.state.bTournamentType} handleStandingIdxChange={this.handleStandingIdxChange} 
						formatTeamIndiv={this.props.season.formatTeamIndiv}	printLeagueMsg={this.props.printLeagueMsg} 
						togglePrintLeagueMsg={this.props.togglePrintLeagueMsg} >
					</PlayerStandings_8B>
				);
			}
			else if (this.props.season.leagueType === myConstClass.LGTYPE_10B) {
				return (
					<PlayerStandings_10B season={this.props.season} standings={this.state.standings}
						standingIdx={this.state.standingIdx} bTournamentType={this.state.bTournamentType} handleStandingIdxChange={this.handleStandingIdxChange} 
						formatTeamIndiv={this.props.season.formatTeamIndiv}	printLeagueMsg={this.props.printLeagueMsg} 
						togglePrintLeagueMsg={this.props.togglePrintLeagueMsg} >
					</PlayerStandings_10B>
				);
			} 
			else if (this.props.season.leagueType === myConstClass.LGTYPE_9B) {
				return (
					<PlayerStandings_9B season={this.props.season} standings={this.state.standings}
						standingIdx={this.state.standingIdx} bTournamentType={this.state.bTournamentType} handleStandingIdxChange={this.handleStandingIdxChange} 
						formatTeamIndiv={this.props.season.formatTeamIndiv}	printLeagueMsg={this.props.printLeagueMsg} 
						togglePrintLeagueMsg={this.props.togglePrintLeagueMsg} >
					</PlayerStandings_9B>
				);
			} 
			else {
				return;
			}
		}
	}

	displaySpinner() {
		return (
  		<div className="row col-md-2">
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  		</div>
  	);
	}

}

export default PlayerStanding;


